import { createFileRoute } from '@tanstack/react-router';
import { TrackDetailPage } from '@/page/TrackDetailPage';

export const Route = createFileRoute('/_app/admin/tracks/$trackId/')({
  component: TrackDetailRoute,
});

function TrackDetailRoute() {
  const { trackId } = Route.useParams();
  return <TrackDetailPage trackId={trackId} />;
}
